import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { PlannerStore, SaveState } from '../../../services/planner-store';
import { LegConnectorComponent } from '../leg-connector/leg-connector.component';
import { StartPointComponent } from '../start-point/start-point.component';
import { StopCardComponent } from '../stop-card/stop-card.component';

@Component({
  selector: 'app-plan-content',
  standalone: true,
  imports: [LegConnectorComponent, StartPointComponent, StopCardComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './plan-content.component.html',
  styleUrl: './plan-content.component.css',
})
export class PlanContentComponent {
  readonly store = inject(PlannerStore);

  readonly stops = this.store.stopListings;
  // Aligned 1:1 with stops(); entry i is the leg leading into stops[i], or null.
  readonly legs = this.store.stopLegs;
  readonly total = computed(() => this.stops().length);
  readonly saveStateLabel = computed(() => saveLabel(this.store.saveState()));

  onRename(ev: Event): void {
    const value = (ev.target as HTMLInputElement).value;
    this.store.renameTrip(value);
  }

  onSave(): void {
    // Anon: navigates to signup with save_planner=1.
    // Logged-in: POST /api/v1/trips (backend reads current session state).
    void this.store.saveTrip();
  }
}

function saveLabel(state: SaveState): string | null {
  switch (state) {
    case 'saving': return 'Cuvam...';
    case 'saved':  return 'Sacuvano ✓';
    case 'error':  return 'Greska - probaj opet';
    default:       return null;
  }
}
